<template>
  <div @click="handleBurgerClicked" class="Menu__burger">
    <MobileMenuOpen class="header__mobile-open"/>
    <MobileMenuClose class="header__mobile-close"/>
  </div>
</template>

<script>
import MobileMenuOpen from '@/assets/svg/mobile-menu-open.svg?inline'
import MobileMenuClose from '@/assets/svg/mobile-menu-close.svg?inline'

export default {
  components: {
    MobileMenuOpen,
    MobileMenuClose
  },
  props: {
    handleBurgerClicked: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="postcss">
.Menu__burger {
  @apply bg-primary-lightest text-primary-dark p-2 cursor-pointer;
}
.Menu__burger:hover {
  @apply bg-primary-lighter;
}
.Menu__burger.isActive {
  @apply bg-primary text-white;
}
.header__mobile-open,
.header__mobile-close {
  @apply fill-current;
}

.Menu__burger .header__mobile-close,
.Menu__burger.isActive .header__mobile-open {
  @apply hidden;
}
.Menu__burger .header__mobile-open,
.Menu__burger.isActive .header__mobile-close {
  @apply block;
}
</style>
